import { createReducer } from 'redux-create-reducer'
import * as ActionTypes from '../actions/actionTypes.js'
// import { omit } from 'lodash'

const uploadsList = {
	pendingItems: { iconUrl: {} },
	uploadedItems: { iconUrl: {} }
}

export const uploads = createReducer(uploadsList, {
	[ActionTypes.FILE_UPLOAD_REQUEST](state, { payload }) {
		return {
			...state,
			pendingItems: {
				...state.pendingItems,
				[payload.id]: {
					name: payload.pendingFile.name,
					size: payload.pendingFile.size,
					preview: payload.pendingFile.preview,
					completed: false
				}
			}
		}
	},
	[ActionTypes.FILE_UPLOAD_SUCCESS](state, { payload }) {
		return {
			...state,
			pendingItems: {
				...state.pendingItems,
				[payload.id]: {
					...state.pendingItems[payload.id],
					completed: true
				}
			},
			uploadedItems: {
				...state.uploadedItems,
				[payload.id]: payload
			}
		}
	},
	[ActionTypes.FILE_UPLOAD_CLEAR](state) {
		return {
			...state,
			pendingItems: { iconUrl: {} },
			uploadedItems: { iconUrl: {} }
		}
	},
	[ActionTypes.FILE_UPLOAD_FAILURE](state, { payload }) {
		return {
			...state
			// pendingItems: omit(state.pendingItems, payload.id),
			// failedItems: { ...state, [payload.item.id]: payload }
		}
	}
})



// WEBPACK FOOTER //
// ./src/reducers/uploads.js